export const CONTRACT_STATUS = {
  PENDING: 'pending',
  CREATED: 'created',
  SENT: 'sent',
  MODIFICATION: 'modification',
  REJECTED: 'rejected',
  SIGNED: 'signed'
};

export const CONTRACT_STATUS_LABELS = {
  pending: 'Pendiente',
  created: 'Creado',
  sent: 'Enviado',
  modification: 'Modificación',
  rejected: 'Rechazado',
  signed: 'Firmado'
};

export const createContract = (data) => ({
  id: '',
  
  // Relación con propuesta
  proposalId: data.proposalId || '',
  proposalTitle: data.proposalTitle || '',
  
  // Título (de la propuesta)
  title: data.title || '',
  description: data.description || '',
  
  // Datos del cliente (obligatorios desde propuesta)
  clientId: data.clientId || '',
  clientName: data.clientName || '',
  clientType: data.clientType || 'individual',
  clientDni: data.clientDni || '',
  clientTaxId: data.clientTaxId || '',
  representativeDni: data.representativeDni || '',
  clientPhone: data.clientPhone || '',
  clientEmail: data.clientEmail || '',
  
  // Dirección (de la propuesta)
  address: {
    street: data.address?.street || '',
    city: data.address?.city || '',
    province: data.address?.province || '',
    zipCode: data.address?.zipCode || '',
    country: data.address?.country || 'España',
  },
  
  // Archivos
  files: data.files || [],
  
  // Estado
  status: data.status || CONTRACT_STATUS.PENDING,
  
  // Versiones
  version: data.version || '1.0',
  versions: data.versions || [],
  
  // Fechas
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  signedAt: data.signedAt || null,
  
  // Metadata
  notes: data.notes || '',
  createdBy: '',
  isActive: true
});